module.exports = __webpack_public_path__ + "img/map-bajo.b8285e5c.png";